@if (displaySearchDialog && !displaySearchDialogResult) {
  <app-customer-advanced-search-form [displaySearchDialog]="displaySearchDialog && !displaySearchDialogResult"
    (onSubmit)="advancedSearch($event)" (onCancel)="hideAdvancedSearch()">
  </app-customer-advanced-search-form>
}
@if (displaySearchDialog && displaySearchDialogResult) {
  <app-customer-advanced-search-form-result [displaySearchDialog]="displaySearchDialog && displaySearchDialogResult"
    [customers]="customers" [totalCustomers]="totalCustomers" [pageSizeCustomers]="customerPageSize"
    (onLoadData) = "onSearchLoadData($event)"
    (onSubmit)="onSubmitSelectedCustomer($event)" (onCancel)="hideAdvancedSearch()">
  </app-customer-advanced-search-form-result>
}